export const SHOW_TOAST = 'SHOW_TOAST'
export const HIDE_TOAST = 'HIDE_TOAST'

export const SUCCESS = 'success'
export const ERROR = 'danger'
